import React from "react";

/** Static hint drawn inside the Measure tool panel. */
const MeasureIllustration: React.FC = () => (
  <div className="measure-illustration">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="91"
      height="79"
      viewBox="0 0 91 79"
      fill="none"
      aria-hidden="true"
    >
      <path
        opacity="0.1"
        d="M80.5 58.9991L4 74.9991L35 1.49915L88 13.9991L80.5 58.9991Z"
        fill="white"
      />
      <path
        d="M4 74.9991L80.5 58.9991L88 13.9991L35 1.49915"
        stroke="#A3A9B9"
        strokeWidth="2"
        strokeDasharray="6 6"
      />
      <circle cx="4" cy="74.9991" r="4" fill="white" />
      <circle cx="80" cy="58.9991" r="3" fill="white" />
      <circle cx="88" cy="13.9991" r="3" fill="white" />
      <path
        d="M48.4043 2.38391L44.5734 24.8763L40.0379 19.7737L35.0397 26.8391L29.5028 23.9906L34.1856 17.2552L26.6285 16.307L48.4043 2.38391Z"
        fill="white"
      />
    </svg>
  </div>
);

export default MeasureIllustration;
